import { render, staticRenderFns } from "./wb-split-bar.vue?vue&type=template&id=67af086d&scoped=true"
import script from "./wb-split-bar.vue?vue&type=script&lang=js"
export * from "./wb-split-bar.vue?vue&type=script&lang=js"
import style0 from "./wb-split-bar.vue?vue&type=style&index=0&id=67af086d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af086d",
  null
  
)

export default component.exports